import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-obsidian flex items-center justify-center p-8">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-gold">
            Er ging iets mis — laad de pagina opnieuw
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
